import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link'
import IconOpenInNew from '@material-ui/icons/OpenInNew'
import OpenSourceNotice from 'static/docs/InsightBoxOpenSourceNotice.pdf'
import styles from './TouLinkRenderer.scss'

const propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
  href: PropTypes.string.isRequired,
}

const defaultProps = {
  children: null,
}

function TouLinkRenderer(props) {
  const {
    href, children, dispatch, ...rest
  } = props

  if (href === 'InsightBoxOpenSourceNotice.pdf') {
    return (
      <a className={styles.link} href={OpenSourceNotice} rel="noopener noreferrer" target="_blank" {...rest}>
        {children}
        <IconOpenInNew fontSize="inherit" />
      </a>
    )
  }

  if (href.startsWith('http')) {
    return (
      <a className={styles.link} href={href} rel="noopener noreferrer" target="_blank" {...rest}>
        {children}
        <IconOpenInNew fontSize="inherit" />
      </a>
    )
  }

  return (
    <Link className={styles.link} to={href} {...rest}>
      {children}
    </Link>
  )
}

TouLinkRenderer.propTypes = propTypes
TouLinkRenderer.defaultProps = defaultProps

export default connect()(TouLinkRenderer)
